import React from 'react';
import { ReactComponent as LogoSVG } from './assets/klydo-greet.svg';

interface GreetLogoProps {
  color?: string;
  width?: string | number;
  style?: React.CSSProperties;
}

const GreetLogo = ({ color, width = 200, style }: GreetLogoProps) => {
  return <LogoSVG width={width} style={style} fill={color} />;
};

export default GreetLogo;
